import Panel from '@/shared/components/Panel';
import { colorAccent, colorText } from '@/utils/palette';
import styled from 'styled-components';

const GpuOneSystemInformation = ({ gpu }) => {
	console.log(gpu);
	return (
		<Panel lg={6} xl={6} md={12} sm={12} title="System Information">
			<InfoGrid>
				<InfoItem>
					<InfoLabel>System Vendor</InfoLabel>
					<InfoValue>{gpu?.system_vendor}</InfoValue>
				</InfoItem>
				<InfoItem>
					<InfoLabel>System Product</InfoLabel>
					<InfoValue>{gpu?.system_product}</InfoValue>
				</InfoItem>
				<InfoItem>
					<InfoLabel>Mainboard Product</InfoLabel>
					<InfoValue>{gpu?.mainboard_product}</InfoValue>
				</InfoItem>
				<InfoItem>
					<InfoLabel>Mainboard Version</InfoLabel>
					<InfoValue>{gpu?.mainboard_version}</InfoValue>
				</InfoItem>
				<InfoItem>
					<InfoLabel>Server</InfoLabel>
					<InfoValue>MAAS Server</InfoValue>
				</InfoItem>
				<InfoItem>
					<InfoLabel>Deployed OS</InfoLabel>
					<InfoValue>{gpu?.deployed_os}</InfoValue>
				</InfoItem>
			</InfoGrid>
		</Panel>
	);
};

export default GpuOneSystemInformation;

const InfoGrid = styled.div`
	display: grid;
	grid-template-columns: 1fr 1fr;
	flex-wrap: wrap;
	gap: 70px;
	margin-top: 60px;
	height: 100%;
`;

const InfoItem = styled.div`
	display: flex;
	flex-direction: column;
	height: 30%;
	align-items: center;
	gap: 10px;
	text-align: left;
	min-width: 0;
	word-wrap: break-word;
	overflow-wrap: break-word;
`;

const InfoLabel = styled.span`
	font-size: 18px;
	color: ${colorAccent};
	font-weight: 500;
	word-wrap: break-word;
	overflow-wrap: break-word;
`;

const InfoValue = styled.span`
	font-size: 18px;
	color: ${colorText};
	font-weight: 600;
	word-wrap: break-word;
	overflow-wrap: break-word;
`;
